import React, { ReactElement } from 'react';
import { Popper } from '@mui/material';
import classNames from '../../../utils/class-names';
import iconMap from '../../../utils/icon-map';
import { SidebarNavItem, SidebarNavSubItem, ZIndexValues } from '../../../types';

interface SidebarItemsPopperProps {
  isCollapsed: boolean;
  anchorEl: HTMLElement | null;
  hoveredItem: SidebarNavItem | null;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClose: () => void;
}

const SidebarItemsPopper = ({
  isCollapsed,
  anchorEl,
  hoveredItem,
  onMouseEnter,
  onMouseLeave,
  onClose,
}: SidebarItemsPopperProps): ReactElement => {
  const renderSidebarSubItemForPopper = (item: SidebarNavSubItem) => {
    const Icon = item.icon ? iconMap[item.icon] : null;
    return (
      <div className="relative" key={item.id}>
        <div className="relative z-0">
          <a
            id={item.id}
            href={item.href}
            className={classNames(
              item.current
                ? 'bg-slate-700 text-white font-medium'
                : 'text-slate-300 hover:bg-slate-900 hover:text-slate-200',
              'nav-item group flex items-center px-2 py-2 text-sm font-normal rounded-md whitespace-nowrap m-auto text-center'
            )}
          >
            {Icon && (
              <Icon
                className={classNames(
                  item.current
                    ? 'text-blue-400'
                    : 'text-slate-400 group-hover:text-slate-400',
                  'mr-3 shrink-0 h-5 w-5'
                )}
                aria-hidden="true"
              />
            )}
            {item.name}
          </a>
        </div>
      </div>
    );
  };

  if (!isCollapsed) return <></>;

  return (
    <Popper
      open={Boolean(anchorEl && hoveredItem)}
      anchorEl={anchorEl}
      placement="right-start"
      style={{ zIndex: ZIndexValues.SIDEBAR_FLYOUT }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="p-2 bg-slate-800">
        {hoveredItem?.subItems?.map((subItem) =>
          renderSidebarSubItemForPopper(subItem)
        )}
      </div>
    </Popper>
  );
};

export default SidebarItemsPopper;
